const apiUrl = (imageUpload?: boolean): string => {
  if (!process.env.REACT_APP_ENVIRONMENT) {
    return 'https://api.nawozy.eu/';
  }

  if (process.env.REACT_APP_ENVIRONMENT === 'local' && imageUpload) {
    return 'https://apitest.nawozy.eu/';
  }

  if (process.env.REACT_APP_ENVIRONMENT === 'local') {
    return 'http://localhost:9002/';
  }

  return process.env.REACT_APP_ENVIRONMENT
    ? process.env.REACT_APP_ENVIRONMENT === 'test'
      ? 'https://apitest.nawozy.eu/'
      : 'https://api.nawozy.eu/'
    : 'https://api.nawozy.eu/';
};
export default apiUrl;
